import Button from "./Button";

export default function EmptyState({ title, description, ctaLabel, onCta }) {
  return (
    <div className="card" style={{ textAlign: "center", padding: 32 }}>
      <div style={{ fontSize: 48, color: "var(--color-border)" }}>□</div>
      <h3 className="h2" style={{ marginTop: 8 }}>
        {title}
      </h3>
      <p className="muted">{description}</p>
      {ctaLabel && onCta ? (
        <Button variant="primary" onClick={onCta}>
          {ctaLabel}
        </Button>
      ) : null}
    </div>
  );
}
